import { API_URL } from '@/config';
import axios from 'axios';

export class BaseApiService {
  constructor() {
    this.api = axios.create({
      baseURL: API_URL || 'https://api.postscrypt.co.uk/api',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });

    // Add request interceptor for auth token
    this.api.interceptors.request.use((config) => {
      const token = localStorage.getItem('auth_token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });
  }
} 